<script>
    export default {
        methods: {
            orderPay(order, callback) {
                this.$confirm(
                    "系统将会在您的账户里扣除￥" + order.amount + "元，确认继续操作吗？如果您需要增值税发票，请注意预留开票金额。",
                    "支付提醒", {
                        confirmButtonText: "确定",
                        showClose: false,
                        cancelButtonText: "取消",
                        type: "warning",
                        beforeClose: (action, instance, done) => {
                            if (action === "confirm") {
                                instance.confirmButtonLoading = true;
                                instance.confirmButtonText = "处理中...";

                                this.$http
                                    .post("payment/request", {
                                        order_id: order.order_id
                                    })
                                    .then(res => {
                                        if (res.success) {
                                            instance.callback = () => {
                                                this.$alert("恭喜您支付成功", "成功", {
                                                    confirmButtonText: "确定",
                                                    type: "success",
                                                    callback: action => {
                                                        if (callback) callback()
                                                    }
                                                })
                                            };
                                        } else {
                                            instance.callback = () => {
                                                this.$alert(res.message, "失败", {
                                                    type: "error"
                                                });
                                            };
                                        }
                                    })
                                    .catch()
                                    .then(() => {
                                        this.loading = false;
                                        instance.confirmButtonLoading = false;
                                        done();
                                    });
                            } else {
                                done();
                            }
                        }
                    }
                );
            }
        }
    };

</script>
